angular
  .module 'filters'
  .filter 'fromNow', ->
    (input) ->
      if input
        hours = Math.round moment(input).diff(moment(), 'hours', true)
        if hours > 2 && hours <=24
          return "in #{hours} hours"
        moment(input).fromNow()
